View = require 'app/scripts/views/internal/view'
templates = require 'app/scripts/views/internal/templates'

module.exports = class FormattingHelpView extends View
  viewTitleKey: 'formatting help'

  render: ->
    @$el.html templates.fill('formatting_help')
    @
